module.exports = __webpack_public_path__ + "static/img/cont57 (4).bd6f6e8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont57 (4).jpg
// module id = eDdh
// module chunks = 0